import { DEPLOYMENT_URL } from './deployment-url';

export const ENVIRONMENT = (() => {
  if (DEPLOYMENT_URL.includes('localhost')) return 'local';
  if (DEPLOYMENT_URL.includes('staging')) return 'staging';
  return 'production';
})();

export const BLUMINT_PROTOCOL = 'blumint' as const;
